module.exports = __webpack_public_path__ + "24c1aae38f9d08f83fc2e6b90451d1a6.png";